import styled, {css} from 'styled-components';

export const StyledBar = styled.span`
  ${({color, theme}) => css`
    border-left: 7px solid ${theme.palette[color].main};
    padding: ${theme.spacing(0, 0, 0, 3)};
  `}
`;
